import { render, staticRenderFns } from "./_article.vue?vue&type=template&id=0030c24a&scoped=true"
import script from "./_article.vue?vue&type=script&lang=js"
export * from "./_article.vue?vue&type=script&lang=js"
import style0 from "./_article.vue?vue&type=style&index=0&id=0030c24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030c24a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogArticle: require('/builds/write/write-app/components/storyblok/blog/Article.vue').default,BlogArticleCard: require('/builds/write/write-app/components/storyblok/blog/ArticleCard.vue').default})
